<template>
  <div class="max_box">
    <!-- 核心修复1：给Tabbar外层加overflow:hidden，限制横向滚动 -->
    <van-tabbar 
      v-model="type" 
      @change="onChange" 
      active-color="#9231f5" 
      inactive-color="#6b7db2" 
      style="border-top: 1px solid #9231f5; box-sizing: border-box; background-color: rgb(243, 246, 255); z-index: 200; width: 100%; overflow: hidden;"
    >
      <van-tabbar-item>
        <span>公告</span>
        <template #icon="props">
          <img :class="{no:!props.active}" :src="props.active ? '/static/image/kf.png' : '/static/image/tabbar_icon0_nor.png'" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>大厅</span>
        <template #icon="props">
          <img :class="{no:!props.active}" :src="props.active ? '/static/image/dt.png' : '/static/image/tabbar_icon1_nor.png'" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>发现</span>
        <template #icon="props">
          <img :class="{no:!props.active}" :src="props.active ? '/static/image/fx.png' : '/static/image/tabbar_icon6_nor.png'" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>优惠</span>
        <template #icon="props">
          <img :class="{no:!props.active}" :src="props.active ? '/static/image/yh.png' : '/static/image/tabbar_icon3_nor.png'" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img :class="{no:!props.active}" :src="props.active ? '/static/image/wd.png' : '/static/image/tabbar_icon5_nor.png'" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data() {
    return { 
      type: 1, // 默认选中大厅
      isNavigating: false // 防止重复跳转
    };
  },
  methods: {
    onChange(type) {
      if (this.isNavigating) return;
      this.isNavigating = true;

      this.type = type;

      const routeMap = {
        0: '/',     // 公告
        1: '/home',     // 大厅
        2: '/discover', // 发现
        3: '/activity', // 优惠
        4: '/mine'      // 我的
      };
      
      this.$router.push({ path: routeMap[type] })
        .catch(err => {
          if (!err.message.includes('Avoided redundant navigation')) {
            console.error('路由跳转失败:', err);
          }
        })
        .finally(() => {
          this.isNavigating = false;
        });
    },
    changPath() {
      const path = this.$route.path;
      const pathToType = {
        '/': 0,
        '/home': 1,
        '/discover': 2,
        '/activity': 3,
        '/mine': 4
      };
      if (pathToType.hasOwnProperty(path)) {
        this.type = pathToType[path];
      }
    },
  },
  mounted() {
    if (this.$route.path === '/') {
      this.$router.push('/home');
    }
    this.changPath();
    // 核心修复2：挂载后强制禁止页面横向滚动
    document.body.style.overflowX = 'hidden';
  },
  watch: {
    $route() {
      this.changPath();
    }
  },
};
</script>

<style lang="scss" scoped>
// 核心修复3：重置所有元素的盒模型，避免宽度溢出
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.max_box{
  height: 52px;
  width: 100%;
  overflow: hidden;
  position: fixed; // 固定在底部，避免随页面滚动位移
  bottom: 0;
  left: 0;
  z-index: 999; // 提高层级，避免被遮挡
}
.van-tabbar-item__icon img {
  display: block;
  height: 20px;
  margin-bottom: 6px;
  width: auto; // 图片宽度自适应，不超出父
}
.van-tabbar-item__icon .no{
  height: 20px;
  margin-bottom: 6px;
}
.van-tabbar-item {
  font-size: 14px;
  flex: 1; // 每个Tab平均分配宽度，避免挤压/溢出
}
.van-tabbar {
  height: 52px; // 改用px固定高度，避免rem适配误差
  width: 100%; // 强制占满父容器
  display: flex; // 弹性布局，确保Tab均分宽度
}
.van-tabbar-item--active {
  background-color: rgb(243, 246, 255);
}
</style>